import React, { Component } from 'react';
import InternalService from '../../services/internal-api';
import Loading from '../loading';

import './emitters.css';

export default class Emitters extends Component {

  stampsData = new InternalService();

  state = {
    dukes: null,
    loading: false
  };

  componentDidMount() {
    this.stampsData.getDukesEnum()
      .then((body) => {
        this.setState({
          dukes: body.data,
        });
      });
  }

  // 🔹 группировка + сортировка
  groupByBranch(arr) {
    const grouped = arr
    .filter(item => item.idBranch && ![3, 10].includes(item.idBranch)) // Не берем группы, созданные для монет
    .reduce((acc, item) => {
      const key = item.idBranch || 'unknown';

      if (!acc[key]) {
        acc[key] = {
          idBranch: item.idBranch,
          name: `${item.branch_en} (${item.branch_ru})` || 'Unknown',
          items: []
        };
      }

      acc[key].items.push(item);
      return acc;
    }, {});

    console.log(grouped)


    Object.values(grouped).forEach(group => {

      // 🔹 сначала сортируем
      group.items.sort((a, b) => {
        const da = a.dateDeath ?? Infinity;
        const db = b.dateDeath ?? Infinity;
        return da - db;
      });
    
      // 🔹 потом делим на нормальные и аномальные
      const normal = [];
      const outliers = [];
    
      group.items.forEach(item => {
        if (item.dateBirth && item.dateDeath) {
          const diff = item.dateDeath - item.dateBirth;
    
          if (diff > 100) {
            outliers.push(item);
            return;
          }
        }
        normal.push(item);
      });
    
      // 🔹 сохраняем раздельно
      group.normal = normal;
      group.outliers = outliers;
    });

    return grouped;
  }

  renderPersonaliaItem(item) {
    const {
      id,
      name,
      name_en,
      dateBirth,
      dateDeath,
      datePower,
      birthProximity,
      powerProximity,
      deathProximity
    } = item;

    const birth = dateBirth ? `${birthProximity ? '≈' : ''}${dateBirth} ` : '';
    const power = datePower ? `ϡ ${powerProximity ? '≈' : ''}${datePower} ` : '';
    const death = dateDeath ? `† ${deathProximity ? '≈' : ''}${dateDeath}` : '';

    const dates = `${birth}${power}${death}`;

    return (
      <div key={`duke${id}`} className="emitter-item">
        <a href={`/person/${id}`}>
          {name_en} ({name})
        </a>
        {dates && ` (${dates})`}
      </div>
    );
  }

  render() {
    const { dukes, loading } = this.state;

    if (!dukes) {
      return <h3>Data is loading.</h3>;
    }

    if (loading) return <Loading />;

    const grouped = this.groupByBranch(dukes);

    return (
      <div className="footer-widget-heading padding-both">
        <h3>Emitters</h3>

        <div className='bukvitsa'>
        Below is an automatically compiled list of known seal issuers from Ancient Rus’, including both individuals and institutions, as documented in published sources. If you wish to suggest additional issuers not included here, please <a href='mailto:creators@kievan-rus.online'>contact us via email</a>.        </div>

        <br />

        {/* 🔹 группы */}
        {Object.entries(grouped).map(([branchId, group]) => (
          <div key={branchId} className="branch-group">
            <h4>{group.name}</h4>

            <div className="emitter-list">
              {group.normal.map(item => this.renderPersonaliaItem(item))}
            </div>

            {/* 🔹 если есть "аномальные" */}
            {group.outliers.length > 0 && (
              <div className="emitter-outliers">
                <div className="emitter-divider">
                  Institutions (организации)
                </div>

                {group.outliers.map(item => this.renderPersonaliaItem(item))}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  }
}